export default "__VITE_ASSET__DWosT6fs__";